import { FC, useCallback, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import './storesPage.scss';

import { List } from 'components/list';
import { NoResult } from '../noResult';
import StoreRow from './storeRow/StoreRow';
import { IStoresPage, IStore2, PageOptions } from 'types';
import { mapPageRouteToPageType, mapPageTypeToTitle } from '../searchResult/helpers';
import { getShops, SearchResultSlicer } from 'store/searchResult/SearchResultActions';
import { onFollowUserToggle } from 'store/profile/ProfileActions';
import { translations } from 'translations/en';

const StoresPage: FC<IStoresPage> = ({
  shops,
  totalCount,
  onFollow,
  getAllShops,
  reset,
  search,
}) => {
  const itemContent = (index: number) => {
    const store = shops ? shops[index] : null;

    if (!store) {
      return null;
    }

    return <StoreRow shop={store} onFollow={onFollow} key={store.id} />;
  };

  const { id } = useParams();

  const location = useLocation();

  const getPageType = useCallback(() => {
    let page = location.pathname.substring(1);

    const slashIndex = page.lastIndexOf('/');

    if (slashIndex !== -1) {
      page = page.slice(0, slashIndex);
    }

    return mapPageRouteToPageType[page];
  }, [location]);

  useEffect(() => {
    const pageType = getPageType();

    if (pageType !== PageOptions.user) {
      reset();
      getAllShops({ page: pageType, id });
    }
  }, []);

  const loadMore = useCallback(() => {
    const pageType = getPageType();

    getAllShops({ page: pageType, id });
  }, []);

  const element = document.getElementById('parent-scroller');

  return (
    <div className="search-container page without-max-width">
      <div className="title">
        <span>{mapPageTypeToTitle[getPageType()]}</span>
      </div>
      <div className="search-inner-container">
        <div id="parent-scroller" className="list-scroller-container">
          <div className="text-container">
            <span className="total-result">
              {totalCount} <span className="result-text">{translations.COMMON.SHOPS}</span>
            </span>
          </div>
          <div className="store-list">
            <List
              scrollerContainer={element}
              hasMore={totalCount > (shops?.length || 0)}
              data={shops}
              emptyState={<NoResult searchText={search} />}
              loadMore={loadMore}
              itemContent={itemContent}
              totalCount={shops?.length}
              isGrid
              overscan={20}
              className="shop-list"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStore2) => {
  const { shops: stateShops, filters } = state.searchResult;

  const { list: shops, totalCount } = stateShops;

  const { search } = filters;

  return { shops, totalCount, search };
};

const mapDispatchToProps = {
  onFollow: onFollowUserToggle,
  getAllShops: getShops,
  reset: SearchResultSlicer.actions.reset,
};

export default connect(mapStateToProps, mapDispatchToProps)(StoresPage);
